<template>
  <div>
    <Modal
      v-model="modal1"
      :footer-hide="true"
      class-name="vertical-center-modal"
    >
      <div class="model-img"></div>
      <div class="model-text">您正在访问加密内容，请先登录！</div>
      <div class="model-button" @click="Tologin()">登录</div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "model",
  data() {
    return {
      modal1: false
    };
  },
  created() {
    GMS.vbus.$on("Modal-Show", res => {
      this.modal1 = true;
    });
  },
  beforeDestroy() {
    GMS.vbus.$off("Modal-Show");
  },
  methods: {
    Tologin() {
      this.modal1 = false;
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
    padding: 0;
  }
  .ivu-modal-content {
    position: relative;
    height: 438px;
    width: 544px;
    background: url("../../../static/img1/弹框背景.png") no-repeat;
    background-size: 100% 100%;
    box-shadow: none;
  }
  .model-img {
    width: 332px;
    height: 278px;
    position: absolute;
    background: url("../../../static/img1/图形.png") no-repeat;
    background-size: 100% 100%;
    top: -77px;
    left: 100px;
  }
  .model-text {
    position: absolute;
    top: 200px;
    align-content: center;
    height: 28px;
    left: 130px;
    line-height: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 20px;
    color: #0f0f0f;
  }
  .model-button {
    cursor: pointer;
    position: absolute;
    top: 280px;
    width: 160px;
    left: 190px;
    height: 44px;
    background: #4066d2;
    border-radius: 22px;
    color: #ffffff;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    line-height: 44px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inside/model.vue